export const enGb = {
  account: "Account",
  accountFlags: "Account flags",
  accountHolder: "Account holder",
  accountHolderVerification: "Account holder verification",
  accountId: "Account ID",
  accountIdentifier: "Account identifier",
  accountMatching: "Account matching",
  accountsBackoffice: "Accounts backoffice",
  accountsBackofficeSections: "Accounts backoffice sections",
  actionConflict:
    "The accounts service couldn't apply this action: the transaction has moved on, or an earlier attempt already reached it. Refreshing the transaction.",
  actionSubjectIncoming: "the incoming {{amount}}",
  actionSubjectIncomingFrom: "the incoming {{amount}} from {{name}}",
  actionSubjectOutgoing: "the outgoing {{amount}}",
  actionSubjectOutgoingTo: "the outgoing {{amount}} to {{name}}",
  administration: "Administration",
  allFilterValues: "{{filter}}: all",
  allTransactions: "All transactions",
  amount: "Amount",
  approveSender: "Approve sender",
  approveSenderDescription:
    "This matches the sender to the account holder, books the payment as a top up and retries the transaction straight away.",
  approveSenderSucceeded: "Sender approved. The transaction is being retried.",
  approveSenderTitle: "Approve the sender",
  atStep: "at {{step}}",
  backToTransactions: "Back to transactions",
  beneficiary: "Beneficiary",
  bounceBackOf: "Bounce back of",
  bouncedBackBy: "Bounced back by",
  cancel: "Cancel",
  checksAndDecisions: "Checks & decisions",
  clearAll: "Clear all",
  clearFilters: "Clear filters",
  comment: "Comment",
  commentOptional: "Comment (optional)",
  correspondingInternal: "Corresponding internal transaction",
  createdAt: "Created",
  customer: "Customer",
  decision: "Decision",
  decisions: "Decisions",
  decisionSubjectAccountHolderVerification: "Account holder verification",
  decisionSubjectTransaction: "Transaction",
  decisionTypeApproved: "Approved",
  decisionTypeRejected: "Rejected",
  direction: "Direction",
  exceptionType: "Exception type",
  exceptionTypeAccountConfigurationError: "Account configuration error",
  exceptionTypeAccountHolderVerificationRejected:
    "Account holder verification rejected",
  exceptionTypeAccountInsufficientFunds: "Insufficient funds",
  exceptionTypeAccountNotMatched: "Account not matched",
  exceptionTypeAccountNotOperational: "Account not operational",
  exceptionTypeProcessingError: "Processing error",
  exceptionTypeSenderVerificationFailed: "Sender verification failed",
  exceptionTypeSystem: "System error",
  exceptionTypeTransactionApprovalTimeout: "Approval timed out",
  exceptionTypeTransactionBeneficiaryCheckRejected:
    "Beneficiary check rejected",
  exceptionTypeTransactionFxNotSupported: "FX not supported",
  exceptionTypeTransactionNotSupportedByAccount: "Not supported by the account",
  exceptionTypeTransactionRejected: "Rejected",
  exceptionTypeTransactionRejectedByBankingProvider:
    "Rejected by the banking provider",
  exceptionTypeTransactionRejectedByUser: "Rejected by the customer",
  executionHistory: "Execution history",
  executionStateExceptionManager: "Exception manager",
  executionStateFailed: "Failed",
  executionStateFinished: "Finished",
  executionStatePending: "Pending",
  executionStateSuspended: "Suspended",
  externalId: "External ID",
  failed: "Failed",
  forceApproved: "Force approved",
  genericErrorDescription:
    "The accounts service returned an error. Try again, and if it keeps failing, check the service logs.",
  genericErrorTitle: "Something went wrong",
  id: "ID",
  initiatedBy: "Initiated by",
  internalReference: "Internal reference",
  lastUpdate: "Last update",
  ledgerCategoryAsset: "Asset",
  ledgerCategoryLiability: "Liability",
  ledgerCodeAccount: "Account",
  ledgerCodeBank: "Bank",
  ledgerCodeClearing: "Clearing",
  ledgerCodeReservation: "Reservation",
  ledgerEntries: "Ledger entries",
  ledgerEntry: "Entry",
  ledgerOperation: "Operation",
  ledgerOperationCredit: "Credit",
  ledgerOperationDebit: "Debit",
  matched: "Matched",
  matchScore: "Match score",
  name: "Name",
  needsAttention: "Needs attention",
  no: "No",
  noAccessDescription:
    "The accounts service refused this request. Ask for a backoffice permission on your Fuzebox admin role.",
  noAccessTitle: "You don't have access",
  noDecisions: "No decisions on this transaction.",
  noExecutionHistory: "No execution steps yet.",
  noLedgerEntries: "No ledger entries for this transaction.",
  noRelatedTransactions: "No related transactions.",
  noStatusHistory: "No status changes yet.",
  noteForAuditLogHelper: "Required. Saved with the return in the audit log.",
  noteForAuditLogRequired: "Note for the audit log *",
  notFoundBreadcrumb: "Not found",
  notFoundDescription:
    "Check the ID, and that you're in the right environment (production or sandbox).",
  notFoundTitle: "Transaction not found",
  noTransactions: "No transactions",
  noTransactionsInQueue: "Nothing in this queue right now.",
  noTransactionsMatchingFilters: "No transactions match these filters.",
  noTransactionsMatchingSearch:
    "No transactions match this search. Search finds payment references and transaction IDs.",
  noTypeChecks: "No type checks for this transaction.",
  operationIncoming: "Incoming",
  operationOutgoing: "Outgoing",
  order: "Order",
  overview: "Overview",
  parties: "Parties",
  paymentRail: "Payment rail",
  paymentRailBacs: "Bacs",
  paymentRailChaps: "CHAPS",
  paymentRailFps: "Faster Payments",
  paymentRailNpp: "NPP",
  paymentRailSepa: "SEPA",
  paymentRailSepaInstant: "SEPA Instant",
  performer: "Performer",
  performerType: "Performer type",
  performerTypeApiClient: "API client",
  performerTypeNotification: "Provider notification",
  performerTypeScheduler: "Scheduler",
  performerTypeUser: "User",
  productFlagCloseLoop: "Closed loop",
  productFlagGatewayPayment: "Gateway payment",
  productFlagInternalTransaction: "Internal transaction",
  productFlagManualCredit: "Manual credit",
  productFlagOpenLoop: "Open loop",
  productFlagRefund: "Refund",
  productFlagSettlement: "Settlement",
  productFlagTopUp: "Top up",
  production: "Production",
  productionActionWarning:
    "This acts on a real transaction and can't be undone.",
  reference: "Reference",
  referenceValue: "Reference: {{reference}}",
  refund: "Refund",
  reject: "Reject",
  rejectDescription:
    "The transaction stops here and isn't processed any further.",
  rejectReasonHelper: "Required. Explain why the transaction is rejected.",
  rejectReasonRequired: "Reason *",
  rejectSucceeded: "Transaction rejected.",
  rejectSummary: "Rejects {{transaction}}.",
  rejectTitle: "Reject the transaction",
  relatedTransactions: "Related",
  relation: "Relation",
  removeFilter: "Remove filter: {{filter}}",
  retry: "Retry",
  retryDescription: "The transaction runs again from the step it stopped at.",
  retrySucceeded: "Retry started.",
  retrySummary: "Retries {{transaction}}, starting again at the {{step}} step.",
  retrySummaryWithoutStep: "Retries {{transaction}}.",
  retryTitle: "Retry the transaction",
  retryWhileSuspendedWarning:
    "It's waiting for the banking provider to respond. Retrying now can send the payment twice.",
  return: "Return",
  returnedBy: "Returned by",
  returnFunds: "Return funds",
  returnOf: "Return of",
  returnReasonAccountCannotBeIdentified: "Account can't be identified",
  returnReasonAccountIsNotInCurrencyQuoted:
    "Account isn't in the currency quoted",
  returnReasonAccountTransferred: "Account transferred",
  returnReasonBeneficiaryAccountClosed: "Beneficiary account closed",
  returnReasonBeneficiaryAccountNameDoesNotMatchBeneficiaryAccountNumber:
    "Beneficiary name doesn't match the account number",
  returnReasonBeneficiaryAccountStopped: "Beneficiary account stopped",
  returnReasonBeneficiaryAccountUnknown: "Beneficiary account unknown",
  returnReasonBeneficiaryDeceased: "Beneficiary deceased",
  returnReasonBeneficiaryNotExpectingFundsOrInstructedReturn:
    "Beneficiary not expecting the funds or asked for a return",
  returnReasonBeneficiarySortCodeUnknown: "Beneficiary sort code unknown",
  returnReasonOther: "Other",
  returnReasonPaymentCannotBeAppliedBecauseOfBeneficiarySensitivities:
    "Can't be applied because of beneficiary sensitivities",
  returnReasonRequired: "Return reason *",
  returnReasonReturnRequestedBySenderOfOriginalPayment:
    "Sender of the original payment asked for a return",
  returnReasonSendingFpsInstitutionActionRequired:
    "Sending FPS institution action required",
  returnReasonTermsAndConditionsOfAccountDoNotPermitCreditingOfFunds:
    "Account terms don't allow crediting the funds",
  returnSucceeded: "Return requested.",
  returnSummary: "Sends {{transaction}} back to the sender.",
  returnTitle: "Return the funds to the sender",
  reversal: "Reversal",
  reversalOf: "Reversal of",
  reversedBy: "Reversed by",
  searchByReferenceOrId: "Search by reference or ID",
  selectReason: "Select a reason",
  sender: "Sender",
  senderName: "Sender name",
  state: "State",
  status: "Status",
  statusHistory: "Status history",
  step: "Step",
  stepAccountAccept: "Account accept",
  stepAccountHolderVerification: "Account holder verification",
  stepAccountInitialVerification: "Account initial verification",
  stepAccountVerification: "Account verification",
  stepAml: "AML",
  stepApprovals: "Approvals",
  stepBankAccept: "Bank accept",
  stepBeneficiaryTrustCheck: "Beneficiary trust check",
  stepBeneficiaryTrustRecord: "Beneficiary trust record",
  stepCompleteReversal: "Complete reversal",
  stepFundsReserve: "Funds reserve",
  stepLinkCompletedTransaction: "Link completed transaction",
  stepPaymentRequest: "Payment request",
  stepReservationPost: "Reservation post",
  stepReturnAccept: "Return accept",
  stepReturnRequest: "Return request",
  stepReversalAccept: "Reversal accept",
  stepReversalLinking: "Reversal linking",
  stepReversalProviderProcessing: "Reversal provider processing",
  stepReversalVerification: "Reversal verification",
  stepSubtypeRecognition: "Subtype recognition",
  stepTransactionVerification: "Transaction verification",
  stoppedAt: "Stopped at {{step}}: {{reason}}",
  stoppedAtStep: "Stopped at {{step}}",
  subject: "Subject",
  suspended: "Suspended",
  transaction: "Transaction",
  transactionId: "Transaction ID",
  transactions: "Transactions",
  transactionStatusCompleted: "Completed",
  transactionStatusCreated: "Created",
  transactionStatusProcessing: "Processing",
  transactionStatusRejected: "Rejected",
  transactionTypeBounceBack: "Bounce back",
  transactionTypeGatewayPayment: "Gateway payment",
  transactionTypeInternal: "Internal",
  transactionTypeManualCredit: "Manual credit",
  transactionTypePayout: "Payout",
  transactionTypeRefund: "Refund",
  transactionTypeReturn: "Return",
  transactionTypeReversal: "Reversal",
  transactionTypeSettlement: "Settlement",
  transactionTypeTopUp: "Top up",
  tryAgain: "Try again",
  type: "Type",
  typeCheckMatched: "Matched",
  typeCheckNotMatched: "Not matched",
  typeChecks: "Type checks",
  uniqueExternalReference: "Unique external reference",
  verificationResultAccountClosed: "Account closed",
  verificationResultCloseMatch: "Close match",
  verificationResultError: "Error",
  verificationResultMatch: "Match",
  verificationResultNoMatch: "No match",
  vpnErrorDescription: "Check VPN connection",
  vpnErrorTitle: "Can't reach the accounts service",
  yes: "Yes",
};
